<template>
  <footer class="invoice-create-footer">
    <div class="invoice-create-footer-left">
      <button type="button" class="app-header-btn app-header-btn--ghost invoice-create-clear-btn" @click="$emit('reset-draft')">
        <i class="fa fa-repeat" aria-hidden="true"></i>
        Limpiar
      </button>
    </div>

    <div class="invoice-create-footer-right">
      <button type="button" class="app-header-btn app-header-btn--secondary" @click="$emit('preview')">
        Vista previa
      </button>
      <button type="button" class="app-header-btn app-header-btn--success" :disabled="submitting" @click="$emit('submit')">
        <i class="fa fa-sticky-note-o" aria-hidden="true"></i>
        <span>{{ submitting ? 'Guardando...' : 'Emitir nota simple' }}</span>
      </button>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SimpleNoteCreateFooterActions',
  props: {
    submitting: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['reset-draft', 'preview', 'submit'],
};
</script>
